import styled from 'styled-components';
import Row from './Row';

export default styled(Row)`
  height: 4rem;
  padding: 0.8rem;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin: 2px 0;

  &.row {
    &:hover {
      background-color: var(--primary100);
    }
    &.selected {
      background-color: var(--primary100);
    }
  }
  .row {
    &__job {
      color: var(--grey900);
      padding: 0.4rem 0;
    }
    &__so {
      color: var(--grey700);
      span {
        padding: 0.4rem;
        border-radius: 0.4rem;
        display: inline-block;
        &.clickable {
          &:hover {
            background-color: var(--primary200);
            color: var(--primary900);
          }
        }
      }
    }
    &__no-results {
      color: var(--error900);
      font-weight: 500;
    }
  }
  .bolded {
    font-weight: bold;
  }
`;
